import React from 'react'
import { Outlet } from 'react-router-dom'

function MainForms() {
  return (
    <div>
      <Outlet/>
    </div>
  )
}

export default MainForms
